import styled from 'styled-components';
import { Form, FormItem, RangePicker } from '@/components';
import { Select } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const StyledFormItem = styled(FormItem)`
  width: 100%;
  margin-bottom: 0;

  &&& .ant-form-item-label {
    width: 95%;
    padding: 0;
    label {
      ${pickThemeFontStyles('12', '14', 'NORMAL')};
      color: ${COLORS.IRON_GRAY};
    }
  }
`;

export const StyledSelect = styled(Select)`
  min-height: 2.75rem;
`;

export const StyledRangePicker = styled(RangePicker)`
  min-height: 2.75rem;
`;
